import root from 'window-or-global';
import get from 'lodash/get';

const graphFlags = environment => get(environment, 'graphFlags', {});

export const getGraphFlags = (environment = root, server = __SERVER__) =>
  server ? null : graphFlags(environment);
